import React from 'react'

import './styles.css'

const SectionWithTitleContent = ({ content }) => {
	return <div className="section-with-title-content">{content}</div>
}

export default SectionWithTitleContent
